var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import styled from 'styled-components';
export var Hide = styled.svg.attrs(function (props) {
  return {
    children: props.title != null ? [React.createElement("title", {
      key: "Hide-title"
    }, props.title), React.createElement("path", {
      d: "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm9.948-6.684a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.952 3.547-4.616 3.56-4.658zm-7.257.961c.191-.389.309-.818.309-1.277 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558l-2.281-2.281z",
      key: "k0"
    })] : [React.createElement("path", {
      d: "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm9.948-6.684a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.952 3.547-4.616 3.56-4.658zm-7.257.961c.191-.389.309-.818.309-1.277 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558l-2.281-2.281z",
      key: "k0"
    })],
    viewBox: '0 0 24 24',
    height: props.height !== undefined ? props.height : props.size,
    width: props.width !== undefined ? props.width : props.size,
    // @ts-ignore - aria is not always defined on SVG in React TypeScript types
    'aria-hidden': props.title == null ? 'true' : undefined,
    focusable: 'false',
    role: props.title != null ? 'img' : undefined,
    "fill": "currentColor"
  };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"])));
Hide.displayName = 'Hide';
export var HideDimensions = {
  height: 24,
  width: 24
};
var templateObject_1;